/** Only local panel pages can be a booking return destination. */
export function adresVozvrata(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')
    || Array.from(value).some(c => c === '\\' || c.charCodeAt(0) <= 32)) return null;
  const path = value.split(/[?#]/)[0];
  // Reject aliases that would bypass the menu visibility check or resolve to a booking again.
  try {
    const decoded = decodeURIComponent(path);
    if (new URL(value, 'https://panel.invalid').pathname !== path || decoded !== path) return null;
  } catch { return null; }
  if (/^\/zapis\/\d+(?:\/|$)/.test(path) || /^\/(?:login|accept-invite)(?:\/|$)/.test(path)) return null;
  return value;
}
export const etoKartochkaZapisi = (path: string) => /^\/zapis\/\d+(?:\/zakrytie)?\/?$/.test(path);
